import type { TOC } from '@ember/component/template-only';
import PageLoading from '../../components/page-loading.gts';

interface Signature {
  Args: {};
}

const ItemsShowLoading: TOC<Signature> = <template>
  <PageLoading
    @title="Item"
    @backRoute="explore"
    @backLabel="Back to explore"
  />
</template>;

export default ItemsShowLoading;
